<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import { frontendURL } from 'dashboard/helper/URLHelper';

const props = defineProps({
  conversation: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const store = useStore();

const funnels = computed(() => {
  // Usar o getter correto do store
  const funnels =
    store.getters['conversationFunnels/getConversationFunnels'](
      props.conversation.id
    ) || [];
  return funnels;
});

// Carregar funis quando o componente for montado
onMounted(() => {
  store.dispatch('conversationFunnels/get', props.conversation.id);
});

const getFunnelDisplayName = funnel => {
  console.log('getFunnelDisplayName -> funnel: ', funnel);
  const pipelineName =
    funnel?.kanban_pipeline?.name ||
    funnel?.kanban_column?.kanban_pipeline?.name;

  const columnName = funnel?.kanban_column?.name;

  if (!pipelineName) return 'Funnel';

  return columnName ? `${pipelineName} - ${columnName}` : pipelineName;
};

const onFunnelClick = (e, funnel) => {
  e.stopPropagation();

  if (!funnel?.kanban_column?.kanban_pipeline?.id) return;

  const path = frontendURL(
    `accounts/${props.conversation.account_id}/kanban/board/${funnel.kanban_column.kanban_pipeline.id}`
  );

  // Tentar navegação com router.push primeiro
  try {
    router.push({ path });
  } catch (error) {
    console.error('CardFunnels - Router push failed:', error);
    // Fallback: usar window.location
    window.location.href = path;
  }
};
</script>

<template>
  <div
    v-if="funnels.length > 0"
    class="flex flex-nowrap gap-1 mt-1 overflow-hidden"
  >
    <div
      v-for="funnel in funnels"
      :key="funnel.id"
      class="inline-flex items-center font-medium text-xs rounded-[4px] gap-1 p-1 bg-transparent text-n-slate-11 dark:text-n-slate-12 border border-solid border-n-strong h-5 cursor-pointer hover:bg-n-slate-3 transition-colors flex-shrink-0"
      @click="onFunnelClick($event, funnel)"
    >
      <i class="i-lucide-git-branch size-3 text-n-slate-10 flex-shrink-0" />
      <span
        :style="{ backgroundColor: funnel.kanban_column.color }"
        class="inline-block w-2 h-2 rounded-sm shadow-sm flex-shrink-0"
      />
      <span class="whitespace-nowrap text-ellipsis overflow-hidden min-w-0">
        {{ getFunnelDisplayName(funnel) }}
      </span>
    </div>
  </div>
</template>
